import { CounterpartyReference } from "@common/schemas/counterpartyReference.schema";

export function buildCounterpartyReferences({
    taskId,
    counterparties,
}: {
    taskId: string;
    counterparties: Array<{ id: string; name: string }>;
}): CounterpartyReference[] {
    return counterparties.map((counterparty) => ({
        taskId,
        counterpartyId: counterparty.id,
        counterpartyName: counterparty.name,
        label: counterparty.name,
    }));
}
